import {connect} from 'react-redux';
import {List} from 'immutable';

import {
  loadResourceCategory,
  updateResourceCategory,
  createResourceCategory,
  deleteResourceCategory,
  resourceCategoryFormDestroy
} from '../../../../../state/modules/resourceCategories/actions';
import ResourceCategoryForm from '../components/ResourceCategoryForm';

const inputs = List([
  'category',
  'status',
  'color_hex',
  'order',
]);

const mapStateToProps = (state, ownProps) => {

  const data = {}, errors = {};
  for (const val of inputs.values()) {
    data[val] = state.entities.getIn(['resourceCategories', ownProps.id, val], '');
    if (state.resourceCategories.getIn(['form', 'errors', val])) {
      errors[val] = state.resourceCategories.getIn(['form', 'errors', val]);
    }
  }

  // change select number values to strings to work with ant design select inputs
  Object.keys(data).forEach(x => {
    if (['status'].includes(x)) {
      data[x] = data[x].toString();
    }
  });

  return {
    isLoading: state.resourceCategories.get('isLoading'),
    isSubmitting: state.resourceCategories.getIn(['form', 'isSubmitting']),
    success: state.resourceCategories.getIn(['form', 'success']),
    created_id: state.resourceCategories.getIn(['form', 'created_id']),
    data: data,
    errors: errors,
    createdAt: state.entities.getIn(['resourceCategories', ownProps.id, 'created_at'], null),
    updatedAt: state.entities.getIn(['resourceCategories', ownProps.id, 'updated_at'], null),
  }
}

const mapDispatchToProps = dispatch => {
  return {
    load: (id, cb) => {
      dispatch(loadResourceCategory(id, cb));
    },
    update: (id, data, cb) => {
      dispatch(updateResourceCategory(id, data, cb));
    },
    create: (data, cb) => {
      dispatch(createResourceCategory(data, cb));
    },
    delete: (id, cb) => {
      dispatch(deleteResourceCategory(id, cb))
    },
    destroyForm: (formState) => {
      dispatch(resourceCategoryFormDestroy(formState));
    }
  }
}

const ResourceCategoryFormContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(ResourceCategoryForm);

export default ResourceCategoryFormContainer;